import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.decisionMaking.relieved',
    subtitle: 'pages.onboarding.decisionMaking.relievedSub',
    value: 'relieved',
  },
  {
    title: 'pages.onboarding.decisionMaking.nervous',
    subtitle: 'pages.onboarding.decisionMaking.nervousSub',
    value: 'nervous',
  },
  {
    title: 'pages.onboarding.decisionMaking.excited',
    subtitle: 'pages.onboarding.decisionMaking.excitedSub',
    value: 'excited',
  },
  {
    title: 'pages.onboarding.decisionMaking.threatened',
    subtitle: 'pages.onboarding.decisionMaking.threatenedSub',
    value: 'threatened',
  },
  {
    title: 'pages.onboarding.decisionMaking.depends',
    subtitle: 'pages.onboarding.decisionMaking.dependsSub',
    value: 'depends',
  },
]

export default function DecisionMakingPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.decisionMaking.title"
      subtitle="pages.onboarding.decisionMaking.subtitle"
    />
  )
}
